/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line import/prefer-default-export
export const regex_password = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/;
